module.exports = __webpack_public_path__ + "static/media/plus.d01614c7.svg";